import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { REST_CHATS } from '../../../../constants';
import { getRestHeadersPatch } from '../../../../helpers/getRestHeadersHelper';
import { Util } from '../../../../../util/util';
import { IComment } from '../../../../../store/model/card/types/IComment';
import { IRestChat } from 'app/types/rest/IRestChat';

//TODO done
/***
 * Почемаем чат как прочитанный
 * @param chatId
 * @param comment
 */
export const markChatAsReadRest = (
    chatId: number,
    comment: IComment,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IRestChat>(
            Util.getApiUrl(`${REST_CHATS}chat/${chatId}/markUserChatAsRead`), {
                ...getRestHeadersPatch(),
                body: JSON.stringify(comment),
            }
        );
    };
    return action;
};
